import React from "react";
import {
    Stack,
    Box,
    Text,
    usePatronTheme,
} from "@unibuddy/patron";

export default function ErrorMessage ({ message }: { message: string }) {
    const theme = usePatronTheme();

    return (
        <Box
            minW={["100%", "100%", 0]}
            padding={["medium", "medium", "large"]}
            paddingTop={["medium", "medium", "large"]}>
            <Stack space="xlarge">
                <Stack>
                    <Text size="medium" color={theme?.FormFieldError?.color}>
                        {message}
                    </Text>
                </Stack>
            </Stack>
        </Box>
    );
};
